import styled from 'styled-components';

const Note = styled.p`
  margin: 12px 0 0;
  color: rgba(255, 255, 255, 0.62);
  font-size: 0.78rem;
  line-height: 1.45;

  a {
    color: #d7c4ff;
  }
`;

function AuthPrivacyNote() {
  return (
    <Note>
      By signing up, you agree that RealityCheck stores your account and activity to personalize your experience. We never sell your personal information.{' '}
      <a href="/privacy">Privacy Policy</a>
    </Note>
  );
}

export default AuthPrivacyNote;
